<template>
  <b-card class="mb-0">
    <b-card-body>
      <b-list-group>
        <b-list-group-item v-for="setting in settings">
          <div class="form-group d-flex align-items-center justify-content-between">
          <span>Notify me when a job starts</span>
          <label class="custom-toggle">
            <input type="checkbox" :checked="onJobStart">
            <span class="custom-toggle-slider rounded-circle" data-label-off="OFF" data-label-on="ON"></span>
          </label>
        </div>
          <div class="form-group d-flex align-items-center justify-content-between">
            <span>Notify me when a job finishes</span>
            <label class="custom-toggle">
              <input type="checkbox" :checked="onJobStart">
              <span class="custom-toggle-slider rounded-circle" data-label-off="OFF" data-label-on="ON"></span>
            </label>
          </div>
        </b-list-group-item>
      </b-list-group>

    </b-card-body>
    <b-card-footer class="d-flex flex-row-reverse">
      <b-button class="btn btn-primary" @click="saveNotifications" variant="outline-primary">Save</b-button>
    </b-card-footer>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      onJobStart: false,
      onJobFinish: false,
      settings: [],
    };
  },
  created() {
    this.$store.dispatch('user/loadWorkspaceUserSettings').then((result) => {
      console.info('loaded user settings', result);
    }).catch((error) => {
      console.warn('error loading user settings', error);
    });
  },
  methods: {
    saveNotifications() {

    },
  },
};
</script>

<style scoped>

</style>
